export type QuizScenariosTranslations = {
  intro: {
    segment1: {
      title: string
      content: Record<number, string>
    }
    segment2: {
      title: string
      content: string
    }
  }
  errors: {
    videoNotSupported: string
    errorBrowser: string
  }
  buttons: {
    next: string
  }
};

export const quizScenariosTranslations: QuizScenariosTranslations = {
  intro: {
    segment1: {
      title: "Eh… Znów to samo. Reset nie pomógł. Co z tym cyber-kompasem?",
      content: {
        1: "O, cześć! Cieszę się, że Cię widzę! Jestem Orin. Dopiero co dołączyłem do Orange i pierwszym zadaniem, jakie dostałem, jest kalibracja mojego kompasu wartości, tylko że on… z jakiegoś powodu przeniósł mnie w czasie i trafiłem tutaj. Ale... może to dlatego, że Ty masz mi w tym pomóc?",
        2: "Aaa, zaraz, zaraz… Widzę, że chcesz dołączyć do praktyk Let’s Orange! Świetnie! Możemy sobie pomóc. Ja skalibruję trzy wartości: odwagę, uważność i odpowiedzialność, a Ty przy okazji dowiesz się, czy Twoje wartości są zbliżone do tych, które są istotne w Orange.",
        3: "To co? Zaczynamy? Chodź, rozegraj to po swojemu! Otwiera się portal - ruszamy w podróż w czasie!"
      }
    },
    segment2: {
      title: "Witaj w przyszłości! Tak, dobrze widzisz. Jesteśmy na Księżycu, który stanowi teraz ważne miejsce na kosmicznej mapie Orange.",
      content: "To tu pracuje się nad tym, by łączność 14G licznych ekspedycji była idealna. Nasz satelita świetnie się do tego nadaje. Warunki pracy nie są tu łatwe, dlatego właśnie roboty, które współpracują z człowiekiem, wykonują najtrudniejsze zadania. Dzieje się, co?"
    },
  },
  errors: {
    videoNotSupported: "Twoja przeglądarka nie obsługuje elementu wideo.",
    errorBrowser: "Błąd sieci lub problem z połączeniem."
  },
  buttons: {
    next: "Dalej"
  }
};
